import { mapState } from "vuex";

export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapState('mobile', ['isMobile']),
    },
    methods: {

    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/title-link/component.js